import NotificationList from './NotificationList'
import notificationListContainer from './notificationListContainer'

export default notificationListContainer(NotificationList)
